export default {
  lang: {
    label: 'Язык',
    en: 'English',
    ru: 'Русский',
  },
  nav: {
    dashboard: 'Дашборд',
    partners: 'Поставщики',
    import: 'Импорт прайсов',
    catalog: 'Каталог',
    specifications: 'Спецификации',
    purchaseOrders: 'Заказы поставщикам',
    storefront: 'Витрина',
    settings: 'Настройки',
    feedback: 'Замечания',
    operations: 'Операции',
    channel: 'Канал продаж',
  },
  shell: {
    hub: 'Партнёрский хаб',
    searchPlaceholder: 'Поиск по артикулу, поставщику',
    newSpec: 'Новая спецификация',
    admin: 'Администратор',
    footer: 'Treejar Trading LLC · Дубай, ОАЭ · Внутренняя партнёрская платформа',
    prices: 'Цены в AED · Данные обновлены 23.10.2026, 09:40',
    openNav: 'Открыть навигацию',
    notifications: 'Уведомления',
    staleTitle: 'Устаревших прайсов: {{count}}',
    staleBody: 'Два дилера не обновляли цены больше недели.',
    reviewPartners: 'Проверить поставщиков',
  },
  common: {
    reset: 'Сбросить',
    save: 'Сохранить',
    cancel: 'Отмена',
    close: 'Закрыть',
    search: 'Поиск',
    add: 'Добавить',
    edit: 'Изменить',
    all: 'Все',
    view: 'Открыть',
    open: 'Открыть',
    back: 'Назад',
    status: 'Статус',
    actions: 'Действия',
    included: 'Включено',
    units: 'шт.',
    items: 'позиций',
    days: 'дн.',
    weeks: 'нед.',
    weekShort: 'нед.',
    stock: 'Остаток',
    category: 'Категория',
    price: 'Цена',
    cost: 'Себестоимость',
    sale: 'Цена продажи',
    margin: 'Маржа',
    of: 'из',
    aed: 'AED',
    vatNoteCosts: 'Себестоимость с учётом скидки дилера · цены продажи без НДС 5%',
    snapshot: 'Срез на 23.10.2026 09:40',
  },
  status: {
    ReadyForPickup: 'Готов к самовывозу',
    PartiallyPickedUp: 'Получен частично',
    PickedUp: 'Получен',
    Closed: 'Закрыт',
    Cancelled: 'Отменён',
    Active: 'Активен',
    Paused: 'Приостановлен',
    Negotiating: 'Переговоры',
    Onboarding: 'Онбординг',
    Draft: 'Черновик',
    New: 'Новый',
    Sent: 'Отправлен',
    Signed: 'Подписан',
    Expired: 'Истёк',
    Confirmed: 'Подтверждён',
    'Picked up': 'Забран',
    Delivered: 'Доставлен',
    Published: 'Опубликован',
    Superseded: 'Заменён',
    Quoted: 'Предложение',
    Won: 'Выигран',
    Lost: 'Проигран',
    Verified: 'Проверен',
    Allowed: 'Разрешено',
    Blocked: 'Заблокировано',
    Fresh: 'Актуален',
    'Special only': 'Только спецпредложение',
    Latest: 'Текущая',
    Invited: 'Приглашён',
    Live: 'На сайте',
    Hidden: 'Скрыт',
    'Own stock': 'Собственный склад',
    Partner: 'Партнёр',
    'Own warehouse': 'Собственный склад',
  },
  category: {
    workstations: 'Рабочие станции',
    desks: 'Столы рабочие',
    chairs: 'Кресла и стулья',
    storage: 'Шкафы и хранение',
    components: 'Комплектующие',
    meetingTables: 'Столы переговорные',
    softSeating: 'Диваны и мягкая мебель',
    pedestals: 'Тумбы',
    execDesks: 'Столы руководителя',
    partitions: 'Перегородки и экраны',
    reception: 'Ресепшн',
    coffeeTables: 'Столы журнальные',
    services: 'Услуги и прочее',
  },
  dashboard: {
    eyebrow: 'Пятница, 23 октября 2026',
    title: 'Обзор партнёрских операций',
    description: 'Состояние общего каталога, ожидаемые поставки и заказы поставщикам по дилерской сети Дубая.',
    importBtn: 'Импортировать прайс',
    manageBtn: 'Управление поставщиками',
    staleCount: '{{count}} прайс-листа старше 7 дней.',
    staleBody: '{{names}} могут поставлять по устаревшим ценам.',
    review: 'Проверить поставщиков',
    kpiActive: 'Активные поставщики',
    kpiActiveHint: 'из {{count}} в сети',
    kpiSkus: 'Артикулы поставщиков',
    kpiUnits: 'Единиц на складах',
    kpiValue: 'Стоимость запасов по себестоимости',
    kpiStale: 'Устаревшие прайсы',
    kpiStaleHint: 'требуется действие',
    liveSnapshot: 'данные онлайн',
    addedOct: '+1 в октябре',
    weekChange: '+7 за неделю',
    resaleTrend: '-312 продано',
    shareTrend: '2,4%',
    overSeven: '> 7 дней',
    freshnessTitle: 'Поставщики и актуальность прайсов',
    freshnessSub: 'Последний принятый прайс по каждому дилеру. Строки старше 7 дней отмечены.',
    viewAll: 'Все',
    colPartner: 'Поставщик',
    colSkus: 'Артикулы',
    colUnits: 'Единиц',
    colDiscount: 'Скидка',
    colLast: 'Обновлён',
    contractGate: 'Договоры: {{can}} из {{total}} поставщиков могут публиковать',
    importNew: 'Импорт нового прайса',
    incomingTitle: 'Ожидаемые поставки',
    incomingSub: 'Ближайшие 3 недели от поставщиков',
    openCatalog: 'Открыть каталог',
    recentPo: 'Последние заказы',
    allPo: 'Все заказы',
    staleBadge: '{{days}} дн.',
  },
  partners: {
    eyebrow: 'Сеть',
    title: 'Поставщики',
    description: 'Дилеры Дубая и Северных эмиратов, чей товар продаёт Treejar. Договор определяет, что можно публиковать.',
    addPartner: 'Добавить поставщика',
    importList: 'Импорт прайса',
    statNetwork: 'Поставщиков в сети',
    statSkus: 'Артикулов в каталоге',
    statUnits: 'Единиц в наличии',
    statDiscount: 'Средняя скидка дилера',
    ofNetwork: 'из {{count}} дилеров рынка',
    searchPlaceholder: 'Поиск поставщика или контакта',
    colPartner: 'Поставщик',
    colContact: 'Контакт',
    colPhone: 'Телефон',
    colSkus: 'Артикулы',
    colUnits: 'Единиц на складе',
    colDiscount: 'Скидка',
    colLast: 'Прайс-лист',
    colStatus: 'Статус',
    stale: 'устарел',
    empty: 'По этому фильтру поставщиков нет.',
    footer: '{{shown}} из {{total}} поставщиков · стоимость каталога {{value}}',
    footerNote: 'Цены поставщиков без НДС · обновление ежедневно в 09:30',
    addTitle: 'Добавить поставщика',
    addSub: 'Пригласите дилера в общий каталог.',
    company: 'Название компании',
    contactName: 'Контактное лицо',
    whatsapp: 'Номер WhatsApp',
    warehouse: 'Адрес склада',
    create: 'Создать поставщика',
    inviteToast: 'Приглашение для нового поставщика подготовлено',
    inviteDetail: 'Статус договора отслеживается в карточке поставщика.',
    cabinet: 'Кабинет',
  },
  pd: {
    back: 'Поставщики',
    notFound: 'Поставщик не найден',
    backToPartners: 'К поставщикам',
    contract: 'Договор: {{status}}',
    message: 'Написать',
    newPriceList: 'Новый прайс',
    pause: 'Приостановить',
    resume: 'Возобновить',
    pauseToast: 'Поставщик приостановлен — товары скрыты с витрины',
    resumeToast: 'Поставщик возобновлён — товары снова в работе',
    openCabinet: 'Открыть кабинет поставщика',
    tabOverview: 'Обзор',
    tabTerms: 'Условия',
    tabContract: 'Договор',
    tabLists: 'Прайс-листы',
    tabSources: 'Источники данных',
    tabProducts: 'Артикулы',
    tabWebOrders: 'Заказы с сайта',
    uploadDocuments: 'Загрузить документы',
    statSkus: 'Артикулов в каталоге',
    statUnits: 'Единиц на складе',
    statDiscount: 'Согласованная скидка',
    statLast: 'Последний прайс',
    daysAgo: '{{days}} дн. назад',
    termsSaved: 'Условия поставщика обновлены',
  },
  ov: {
    company: 'Компания',
    companySub: 'Юридические и торговые данные в системе',
    tradingName: 'Торговое название',
    contact: 'Основной контакт',
    phone: 'Телефон / WhatsApp',
    email: 'E-mail',
    emirate: 'Эмират',
    since: 'Партнёр с',
    payment: 'Условия оплаты',
    vat: 'Регистрация НДС',
    warehouse: 'Склад',
    pickupOnly: 'Только самовывоз',
    deliveryAvailable: 'Возможна доставка',
    directions: 'Маршрут',
    notes: 'Заметки',
    notesSub: 'Только для внутреннего использования — не видно на витрине',
    snapshot: 'Коммерческий срез',
    discount: 'Скидка по прайсу',
    special: 'Скидка на спецпредложения',
    notDiscounted: 'Без скидки',
    discounted: 'Со скидкой',
    catalogValue: 'Стоимость каталога по себестоимости',
    reservation: 'Бронь остатков',
    minResale: 'Минимальная цена перепродажи',
    rating: 'Рейтинг поставщика',
    latestList: 'Последний прайс-лист',
    noList: 'Прайс не загружен',
    import: 'Импорт',
    compliance: 'Комплаенс',
    contract: 'Договор',
    licence: 'Торговая лицензия',
    publishing: 'Публикация на витрине',
    daysOld: '{{days}} дн. назад',
    spend: 'Закупки с 2023',
  },
  terms: {
    title: 'Коммерческие условия',
    sub: 'Применяются ко всем импортам прайсов этого поставщика, если строка не переопределяет.',
    discount: 'Скидка от цены поставщика',
    payment: 'Условия оплаты',
    reservation: 'Срок брони остатков',
    minResale: 'Минимальная цена перепродажи',
    specialLabel: 'Спецпредложения: без скидки',
    specialDesc: 'Строки со спецпредложением идут по цене поставщика как себестоимость, независимо от согласованной скидки.',
    delivery: 'Доставка или самовывоз',
    deliveryOpt: 'Доставка',
    pickupOpt: 'Самовывоз',
    pickupNote: 'Транспорт организует Treejar. Стоимость вывоза добавляется отдельной строкой в заказ.',
    deliveryNote: 'Поставщик доставляет на объект. Минимальная сумма и стоимость рейса — по договору.',
    save: 'Сохранить условия',
    guardTitle: 'Ограничения перепродажи',
    guardSub: 'Контролируются в каталоге и в конструкторе спецификаций',
    guard1: 'Цена продажи не может быть ниже минимальной цены перепродажи даже при проектной скидке.',
    guard2: 'Спецпредложения исключены из автоматических скидок и помечены в спецификации.',
    guard3: 'Публикация на витрине возможна только при подписанном договоре.',
    preview: 'Расчёт цены',
    previewSub: 'Живой расчёт с условиями выше',
    partnerPrice: 'Цена поставщика',
    cost: 'Себестоимость для Treejar',
    markup: 'Типовая наценка 40%',
    suggested: 'Рекомендованная цена',
    example: 'Пример: CH-229A кресло с сетчатой спинкой. Скидка применяется до наценки, опции — после.',
    log: 'История изменений',
  },
  ct: {
    title: 'Договор на перепродажу',
    signed: 'Подготовлен Treejar, подписан обеими сторонами. Артикулы поставщика можно публиковать на витрине.',
    expired: 'Договор истёк 31.08.2026. Публикация заблокирована до продления.',
    pending: 'Договор отправлен поставщику и ждёт подписи. Публикация заблокирована.',
    storefront: 'Витрина',
    document: 'Документ договора',
    documentSub: 'Подготовлен юристами Treejar, версия 3',
    download: 'Скачать договор',
    preview: 'Просмотр',
    start: 'Начало договора',
    end: 'Окончание договора',
    signedByTreejar: 'Подписан Treejar',
    signedByPartner: 'Подписан поставщиком',
    law: 'Применимое право',
    notice: 'Срок уведомления',
    rule: 'Правило публикации',
    ruleSub: 'Что открывает договор на витрине',
    allowed: 'Разрешено при подписанном договоре',
    allowed1: 'Публиковать артикулы на treejartrading.ae',
    allowed2: 'Добавлять остатки в спецификации клиентов',
    allowed3: 'Выставлять заказы поставщику',
    blocked: 'Заблокировано',
    blocked1: 'Новые публикации на витрине',
    blocked2: 'Приём импорта прайсов',
    blocked3: 'Применение скидки',
    actions: 'Действия',
    send: 'Отправить на подпись',
    resend: 'Отправить повторно',
    renew: 'Начать продление',
    privacy: 'Файлы договоров хранятся приватно и доступны только администраторам и менеджерам.',
    history: 'История договора',
    sentTo: 'Запрос на подпись отправлен {{name}}',
    downloaded: 'PDF договора скачан',
    noFile: 'Договор для этого поставщика ещё не создан — оформите его в разделе «Онбординг»',
    downloadFailed: 'Не удалось скачать PDF договора',
    previewFailed: 'Не удалось открыть PDF договора',
    openedToast: 'Просмотр договора открыт',
    renewToast: 'Черновик продления создан — действует 12 месяцев с 01.11.2026',
  },
  lists: {
    current: 'Текущая версия',
    itemsLatest: 'Артикулов в прайсе',
    uploads: 'Загрузок за год',
    daysSince: 'Дней с обновления',
    history: 'История загрузок',
    historySub: 'Каждый принятый импорт создаёт новую неизменяемую версию. Поставщик не уведомляется автоматически.',
    upload: 'Загрузить',
    colVersion: 'Версия',
    colDate: 'Дата',
    colItems: 'Артикулы',
    colChanges: 'Изменения',
    colBy: 'Загрузил',
    colStatus: 'Статус',
    empty: 'Прайс-листы ещё не загружены.',
    footer: 'Версия {{version}} активна в каталоге · старые версии хранятся для аудита',
  },
  pp: {
    warning: 'Договор в статусе «{{status}}», поэтому артикулы нельзя публиковать на витрине. Их можно добавлять во внутренние спецификации.',
    title: '{{count}} артикулов от {{name}}',
    sub: 'Поставщик скрыт на витрине; его цена — только для внутреннего использования.',
    openCatalog: 'Открыть каталог',
    colItem: 'Артикул',
    colCategory: 'Категория',
    colStock: 'Остаток',
    colPartnerPrice: 'Цена поставщика',
    colCost: 'Себестоимость',
    colSale: 'Цена продажи',
    colMargin: 'Маржа',
    colStorefront: 'Витрина',
    footer: 'Публикация идёт под брендом Treejar. Названия поставщиков, их цены и скидки не показываются клиентам.',
  },
  cabinet: {
    back: 'Поставщик',
    title: 'Кабинет поставщика',
    subtitle: 'Артикулы, логистические данные и ценовое соглашение с {{name}}. Тот же вид, что видит дилер после входа.',
    access: 'Доступ в кабинет',
    portalEmail: 'Логин в кабинет',
    portalUsers: 'Активных пользователей',
    lastLogin: 'Последний вход',
    inviteUser: 'Пригласить пользователя',
    inviteSent: 'Приглашение в кабинет отправлено поставщику',
    kpiArticles: 'Артикулов в кабинете',
    kpiUnits: 'Единиц в наличии',
    kpiValue: 'Стоимость запасов',
    kpiShare: 'Доля в закупках',
    kpiSpend: 'Закупки с 2023',
    articles: 'Артикулы',
    articlesSub: 'Каждый артикул с коммерческими и логистическими данными. Нажмите на строку, чтобы открыть карточку товара.',
    colArticle: 'Артикул Treejar',
    colSupplier: 'Артикул поставщика',
    colName: 'Наименование',
    colCategory: 'Категория',
    colWeight: 'Вес',
    colDims: 'Габариты, мм',
    colCbm: 'Объём, м³',
    colPacking: 'Упаковка',
    colStock: 'Остаток',
    colPartnerPrice: 'Цена поставщика',
    colDiscount: 'Скидка',
    colCost: 'Себестоимость',
    colSale: 'Цена продажи',
    colMargin: 'Маржа',
    colLead: 'Срок поставки',
    colStatus: 'Статус',
    addArticle: 'Добавить артикул',
    addTitle: 'Новый артикул',
    addSub: 'Добавьте товар в кабинет поставщика с весом и логистикой.',
    fName: 'Наименование',
    fSku: 'Артикул поставщика',
    fCategory: 'Категория',
    fWeight: 'Вес, кг',
    fDims: 'Габариты Ш×Г×В, мм',
    fCbm: 'Объём, м³ за единицу',
    fPacking: 'Упаковка',
    fPrice: 'Цена поставщика, AED',
    fStock: 'Остаток сейчас',
    fLead: 'Срок поставки',
    create: 'Сохранить артикул',
    created: 'Артикул {{sku}} добавлен в кабинет',
    noArticles: 'Артикулов пока нет — импортируйте прайс или добавьте вручную.',
    logistics: 'Логистика',
    logisticsSub: 'Применяется по умолчанию ко всем отгрузкам этого дилера.',
    warehouse: 'Адрес склада',
    deliveryMode: 'Способ получения',
    leadTime: 'Стандартный срок поставки',
    incoterm: 'Инкотермс',
    minOrder: 'Минимальный заказ',
    origin: 'Страна происхождения',
    payment: 'Условия оплаты',
    reservation: 'Срок брони',
    pickup: 'Самовывоз Treejar',
    delivery: 'Доставка поставщиком',
    pricing: 'Ценовое соглашение',
    pricingSub: 'Скидка применяется к цене поставщика до наценки.',
    markup: 'Наценка',
    saleFormula: 'Цена продажи = себестоимость × (1 + наценка) + доплаты за опции',
    documents: 'Документы',
    contract: 'Договор на перепродажу',
    priceList: 'Текущий прайс-лист',
    expires: 'Действует до {{date}}',
    openProduct: 'Открыть',
    summary: 'Сводка кабинета',
  },
  catalog: {
    eyebrow: 'Каталог',
    title: 'Товар к продаже: свой склад и поставщики',
    description: 'Себестоимость уже с учётом скидки дилера. Названия поставщиков остаются внутренними.',
    importPrices: 'Импорт цен',
    buildSpec: 'Собрать спецификацию',
    itemsCount: '{{count}} позиций',
    split: '{{partner}} от поставщиков · {{own}} свои',
    filters: 'Фильтры',
    search: 'Поиск',
    searchPlaceholder: 'Артикул или название',
    source: 'Источник',
    own: 'Свой',
    partner: 'Поставщик',
    allPartners: 'Все поставщики',
    category: 'Категория',
    allCategories: 'Все категории',
    availability: 'Наличие',
    inStockOnly: 'Только в наличии',
    inStockHint: 'Скрывает позиции с нулевым остатком',
    priceRange: 'Цена продажи',
    colour: 'Цвет',
    baseType: 'Тип основания',
    sortMargin: 'Лучшая маржа',
    sortPriceLow: 'Цена по возрастанию',
    sortPriceHigh: 'Цена по убыванию',
    sortStock: 'Объём остатка',
    sortSku: 'Артикул',
    grid: 'Плитка',
    table: 'Таблица',
    emptyTitle: 'Ничего не найдено',
    emptyBody: 'Расширьте диапазон цены или сбросьте фильтр по цвету.',
    resetFilters: 'Сбросить фильтры',
    footerNote: '{{count}} активных поставщиков · названия поставщиков не видны на витрине',
    colItem: 'Позиция',
    colCategory: 'Категория',
    colSource: 'Источник',
    colStock: 'Остаток',
    colCost: 'Себестоимость',
    colSale: 'Цена',
    colMargin: 'Маржа',
    colStorefront: 'Витрина',
    inStock: '{{count}} в наличии',
    incoming: '0 · {{qty}} в пути',
    marginPct: 'маржа {{value}}%',
    costLabel: 'Себест. {{value}}',
  },
  product: {
    back: 'Каталог',
    notFound: 'Товар не найден',
    backToCatalog: 'К каталогу',
    viewSpecs: 'Спецификации',
    addToSpec: 'В спецификацию',
    inStock: '{{count}} в наличии',
    incoming: '0 сейчас · {{qty}} через 2 недели',
    special: 'Спецпредложение · без скидки',
    colour: 'Цвет',
    base: 'Основание',
    packing: 'Упаковка',
    cbm: 'Объём, м³',
    stockGroup: 'Группа остатков',
    shipsFrom: 'Отгрузка со',
    treejarWarehouse: 'склад Treejar, Al Quoz',
    partnerWarehouse: 'склад поставщика',
    stockPosition: 'Наличие',
    totalUnits: '{{count}} ед. всего',
    nowUnits: 'Сейчас {{count}}',
    arriving: '{{qty}} к {{date}}',
    noInbound: 'Поставок нет',
    specsTitle: 'Характеристики',
    optionsTitle: 'Доступные опции',
    swatches: 'Образцы ткани',
    supplyTitle: 'Источник поставки',
    internalOnly: 'внутреннее',
    partner: 'Поставщик',
    contract: 'Договор',
    lastList: 'Последний прайс',
    reservation: 'Бронь',
    openPartner: 'Открыть поставщика',
    pricingTitle: 'Цена',
    partnerPrice: 'Цена поставщика',
    discount: 'Скидка {{value}}',
    cost: 'Себестоимость',
    markup: 'Наценка',
    salePrice: 'Цена продажи',
    marginAed: 'Маржа, AED',
    marginPct: 'Маржа, %',
    minResale: 'Минимальная цена перепродажи: {{rule}}. Доплаты за опции добавляются после наценки.',
    storefront: 'Витрина',
    publishLabel: 'Публиковать на витрине',
    publishDesc: 'Показывается под брендом Treejar с ценой и статусом наличия.',
    previewListing: 'Посмотреть карточку',
    usedIn: 'Используется в спецификациях',
    notUsedYet: 'Пока не используется ни в одной спецификации.',
    siteSales: 'Продажи на treejartrading.ae',
    siteSalesNone: 'Сайт ещё не передавал продажи.',
    siteSales30d: 'За 30 дней',
    siteSalesRevenue30d: 'Выручка сайта за 30 дней',
    siteSalesTotal: 'За всё время',
    siteSalesLast: 'Последняя продажа',
    siteSalesUnitsOrders: '{{units}} шт. · {{orders}} заказов',
    addTitle: 'Добавить в спецификацию',
    specification: 'Спецификация',
    quantity: 'Количество',
    availableNow: '{{count}} доступно сейчас на {{source}}',
    arrivingNote: '0 доступно · {{qty}} поступление {{date}}',
    addLine: 'Добавить строку',
    added: 'Добавлено {{qty}} × {{sku}} в {{spec}}',
    publishBlocked: 'Публикация невозможна — договор {{partner}} в статусе «{{status}}»',
    publishedToast: 'Опубликовано на treejartrading.ae',
    hiddenToast: 'Скрыто с витрины',
    logisticsTitle: 'Логистика и вес',
    logisticsSub: 'Используется для расчёта фрахта, упаковочных листов и слотов доставки.',
    weight: 'Вес брутто',
    dims: 'Габариты (Ш×Г×В)',
    leadTime: 'Срок поставки',
    origin: 'Страна происхождения',
    incoterm: 'Инкотермс',
    hsCode: 'Код ТН ВЭД',
    minOrder: 'Минимальный заказ',
    supplierArticle: 'Артикул поставщика',
    unitsPerCarton: 'Единиц в коробке',
    carton: 'шт. в коробке',
    noPartner: 'Собственный склад',
    cubeNote: 'Объём считается на упакованную единицу и влияет на стоимость доставки.',
    markupSaved: 'Наценка сохранена — цена сайта пересчитана',
    noCbm: 'нет CBM',
    lotKind: { old_stock: 'Старый сток', new_stock: 'Новый сток', incoming: 'Поступление' },
    reservationDays: '{{count}} дн.',
    oldStockPrice: 'Цена старого стока',
    markupAuto: 'По правилу · {{value}}%',
    markupSource: {
      product: 'Наценка задана для этого товара (приоритет над правилами).',
      partner_category: 'Правило для этого партнёра и категории.',
      partner_rule: 'Правило для этого партнёра.',
      category: 'Правило для категории.',
      partner: 'Наценка партнёра по умолчанию.',
      default: 'Наценка рабочего пространства по умолчанию.',
    },
    manualSite: 'Ручная цена сайта',
    minResaleRule: {
      none: 'нет',
      partner_price: 'не ниже цены партнёра',
      markup_over_cost: 'не ниже себестоимость + {{value}}% ({{price}})',
      per_sku: 'по SKU: {{price}}',
    },
    openOnSite: 'Открыть на сайте',
    noOpenSpecs: 'Открытых спецификаций нет — сначала создайте',
    newSpecLink: 'Новая спецификация',
  },
  imp: {
    eyebrow: 'Импорт прайс-листа',
    title: 'Превратите прайс поставщика в склад каталога',
    description: 'Загрузите файл дилера, провёрьте распознанные строки, исправьте спорные ячейки и опубликуйте новую версию — она сразу попадёт в спецификации.',
    history: 'История импорта',
    newImport: 'Новый импорт',
    step1: 'Загрузка',
    step1Hint: 'PDF, Excel или фото',
    step2: 'ИИ-распознавание',
    step2Hint: '30 страниц',
    step3: 'Проверка позиций',
    step3Hint: '148 строк',
    step4: 'Сравнение версий',
    step4Hint: 'Публикация',
    doneTitle: 'Версия {{version}} опубликована',
    doneBody: '{{count}} позиций от {{partner}} теперь в каталоге. Применено: 2 новые позиции, 1 удаление и 7 изменений цен или остатков. Спецификации, выставленные ранее, сохраняют свои цены.',
    statItemsLive: 'Позиций в каталоге',
    statPriceCuts: 'Цены снижены',
    statPriceRises: 'Цены повышены',
    statStorefront: 'Витрина',
    updated: 'Обновлена',
    openCatalog: 'Открыть каталог',
    viewPartner: 'Карточка поставщика',
    importAnother: 'Загрузить ещё',
    toastTitle: 'Версия {{version}} опубликована — обновлено {{count}} позиций',
    toastDetail: 'Менеджер поставщика уведомлён. Цены в каталоге актуальны.',
  },
  impUpload: {
    title: 'Загрузка прайс-листа поставщика',
    sub: 'Перетащите файл или выберите его. Принимаются сканы и фото со телефона — распознаются таблицы, примечания об остатках и доплаты за опции.',
    dropTitle: 'Перетащите прайс-лист сюда',
    dropSub: 'PDF, XLSX, CSV, JPG или PNG · до 40 МБ',
    browse: 'Выбрать файл',
    fileMeta: '{{size}} · обнаружено страниц: {{pages}}',
    remove: 'Удалить файл',
    lookTitle: 'Что распознаёт система',
    look1Title: 'Цены и скидки',
    look1Text: 'Прайсовая цена, цена старого остатка, отметки спецпредложений.',
    look2Title: 'Остатки и поступления',
    look2Text: 'Остаток сейчас, ожидаемое количество и срок по каждому артикулу.',
    look3Title: 'Опции',
    look3Text: 'Тип основания, подлокотники и доплаты за ткань.',
    look4Title: 'Общие остатки',
    look4Text: 'Позиции, которые берутся с одного физического склада.',
    settingsTitle: 'Параметры импорта',
    partner: 'Поставщик',
    contractStatus: 'Статус договора',
    contractSigned: 'Подписан · действует до 31.10.2026',
    notify: 'Уведомить менеджера поставщика после публикации новой версии',
    merge: 'Автоматически объединять дубли артикулов и помечать конфликты',
    start: 'Запустить распознавание',
    prevTitle: 'Предыдущая версия',
    prevMeta: 'v11 · 07.10.2026',
    prevItems: '141 позиция',
    prevBody: 'Новый прайс будет сравнён с v11 до публикации. Ничего не попадёт в каталог без вашего подтверждения.',
    formats: 'Форматы',
  },
  impExtract: {
    titleRun: 'Распознаём таблицы и примечания',
    titleDone: 'Распознавание завершено',
    meta: '{{file}} · {{pages}} страниц · поставщик {{partner}}',
    pageOf: 'Страница {{page}} из {{total}}',
    complete: 'Готово',
    progressLine: 'Страница {{page}} из {{total}} — найдено {{items}} позиций',
    extracted: 'Распознано {{count}} позиций',
    statItems: 'Найдено позиций',
    statTables: 'Таблиц прочитано',
    statDuplicates: 'Дублей объединено',
    statUnreadable: 'Нечитаемых ячеек',
    pause: 'Пауза',
    resume: 'Продолжить',
    skip: 'Перейти к результату',
    logTitle: 'Журнал страниц',
    logSub: 'Каждая строка — страница исходного документа.',
    page: 'Страница {{page}}',
    queued: 'В очереди',
    items: '{{count}} позиций',
    reading: 'Читаем…',
    sourceTitle: 'Исходная страница',
    region: 'Страница {{page}} · область таблицы',
    sourceNote: 'Сканы низкого качества читаются моделью компоновки; каждая ячейка хранит ссылку на свою страницу.',
    rulesTitle: 'Правила проверки',
    rule1: 'Строки с высокой уверенностью идут в каталог как есть',
    rule2: 'Строки «Проверить» требуют одного клика',
    rule3: 'Строки с низкой уверенностью выделены и блокируют публикацию',
    review: 'Проверить {{count}} позиций',
    backUpload: 'Назад к загрузке',
    note: 'В каталог ничего не записывается до публикации на последнем шаге.',
  },
  impReview: {
    banner1: 'Дубли объединены: {{count}}',
    banner2: 'общих групп остатков: {{count}}',
    bannerRest: 'Остаток считается один раз на группу, чтобы спецификации не бронировали одни и те же единицы дважды.',
    showLow: 'Только низкая уверенность',
    showAll: 'Показать все строки',
    title: 'Проверка распознанных позиций',
    draft: 'черновик v{{version}}',
    sub: 'Нажмите на выделенную ячейку, чтобы исправить. Жёлтые строки требуют внимания перед публикацией.',
    all: 'Все',
    high: 'Высокая',
    check: 'Проверить',
    low: 'Низкая',
    searchPlaceholder: 'Поиск по артикулу, названию, цвету',
    searchAria: 'Поиск по распознанным строкам',
    lowRows: 'Строк с низкой уверенностью: {{count}}',
    rowsShown: '{{shown}} из {{total}} строк',
    selected: 'выбрано {{count}}',
    colItem: 'Позиция',
    colCategory: 'Категория',
    colColour: 'Цвет',
    colStockNow: 'Остаток',
    colIncoming: 'Поступление',
    colPartnerPrice: 'Цена поставщика',
    colOldPrice: 'Цена старого остатка',
    colOptions: 'Опции / доплаты',
    colStockGroup: 'Группа остатков',
    colPacking: 'Упаковка',
    colConfidence: 'Уверенность',
    merged: 'объединено',
    newItem: 'новое',
    selectAll: 'Выбрать все строки',
    selectRow: 'Выбрать {{sku}}',
    back: 'Назад',
    compare: 'Сравнить с v{{version}}',
    footer: 'Показано {{shown}} из {{total}} распознанных строк · обработано страниц: {{pages}}',
  },
  impDiff: {
    statNew: 'Новые позиции',
    statRemoved: 'Удалённые позиции',
    statPrice: 'Изменения цен',
    statStock: 'Изменения остатков',
    typeNew: 'Новая позиция',
    typeRemoved: 'Удалена',
    typePrice: 'Изменение цены',
    typeStock: 'Изменение остатка',
    title: 'Изменения относительно v{{version}}',
    sub: '07.10.2026 · 141 позиция → сегодня · {{count}} позиций. Показаны только отличия.',
    allChanges: 'Все изменения',
    colChange: 'Изменение',
    colSku: 'Артикул',
    colItem: 'Позиция',
    colValues: 'Было → стало',
    removedValue: 'удалено',
    empty: 'Изменений этого типа нет.',
    publishTitle: 'Опубликовать {{count}} позиций как v{{version}}',
    publishSub: 'Цены и остатки заменят v{{version}}. Действующие спецификации сохраняют согласованные цены.',
    back: 'Назад',
    publishBtn: 'Опубликовать {{count}} позиций',
    confirmTitle: 'Опубликовать версию {{version}}?',
    confirmBody: '{{count}} позиций от {{partner}} станут действующей версией каталога. Прежние цены сохраняются в архиве для аудита.',
    confirmCheck: 'Одновременно передать видимые позиции на витрину',
    cancel: 'Отмена',
    publishNow: 'Опубликовать',
  },
  spec: {
    eyebrow: 'Спецификации',
    title: 'Спецификации клиентов',
    description: 'Собирайте проектные комплекты из своего склада и остатков поставщиков. Предупреждения появляются, как только количество превышает наличие.',
    browseCatalog: 'Открыть каталог',
    newSpec: 'Новая спецификация',
    openProjects: 'Открытых проектов',
    pipelineSale: 'Сумма предложений',
    projectedMargin: 'Прогноз маржи',
    stockRiskLines: 'Строк с риском остатка',
    allTitle: 'Все спецификации',
    sorted: 'Сортировка по дате поставки',
    colSpec: 'Спецификация',
    colClient: 'Клиент',
    colOwner: 'Ответственный',
    colDelivery: 'Поставка',
    colLines: 'Строк',
    colSale: 'Продажа',
    colMargin: 'Маржа',
    colStatus: 'Статус',
    lineMeta: '{{lines}} позиций · {{units}} ед.',
    footer1: '{{count}} спецификаций · всего строк: {{lines}}',
    footer2: 'Цены предложения фиксируются на 14 дней с даты выставления',
    needApproval: 'Нужно согласование',
    untitled: 'Проект без названия',
    empty: 'Спецификаций пока нет. Создайте первую и добавьте позиции из каталога.',
  },
  specDetail: {
    back: 'Спецификации',
    notFound: 'Спецификация не найдена',
    backToSpec: 'К спецификациям',
    owner: 'Ответственный {{name}}',
    deliveryMeta: '{{client}} · поставка {{date}}',
    saveDraft: 'Сохранить черновик',
    createPo: 'Создать заказы поставщикам',
    client: 'Клиент',
    project: 'Проект',
    deliveryDate: 'Дата поставки',
    linesTitle: 'Строки спецификации',
    linesSub: 'Выберите строку, чтобы увидеть аналоги от других поставщиков. Предупреждения о нехватке ничего не блокируют — они показывают риск.',
    addItem: 'Добавить позицию',
    colItem: 'Позиция',
    colSource: 'Источник',
    colQty: 'Кол-во',
    colAvailable: 'В наличии',
    colOption: 'Опция',
    colCost: 'Себест.',
    colSale: 'Продажа',
    colLineMargin: 'Маржа строки',
    own: 'Свой',
    short: 'не хватает {{count}}',
    remove: 'Удалить {{sku}}',
    noLines: 'Строк пока нет. Добавьте позиции из каталога.',
    footer: '{{items}} позиций · {{units}} ед. · рисков по остаткам: {{risk}}',
    costLabel: 'Себестоимость',
    saleLabel: 'Продажа',
    marginLabel: 'Маржа',
    totalsTitle: 'Итоги проекта',
    salePrice: 'Цена продажи',
    costAtPartner: 'Себестоимость по цене поставщика',
    marginPct: 'Маржа, %',
    vat: 'НДС 5%',
    totalInclVat: 'Итого с НДС',
    split: 'Автоматически разбивается на {{count}} поставщиков',
    findAlt: 'Найти аналоги',
    forLine: 'Для {{sku}} · {{category}}',
    selectLine: 'Выберите строку',
    inStock: '{{count}} в наличии',
    swapIn: 'Заменить',
    noAlt: 'В этой категории у других поставщиков аналогов нет.',
    searchFull: 'Искать по всему каталогу',
    riskTitle: 'Риск остатка',
    riskLine: '{{sku}} — нужно на {{count}} ед. больше, чем есть у поставщика',
    riskOk: 'Все строки в пределах наличия',
    poTitle: 'Разбить на заказы поставщикам',
    poSub: '{{id}} · строки группируются по поставщикам. Строки своего склада не заказываются.',
    poLines: '{{count}} строк · {{units}} ед.',
    poEmpty: 'Нет строк поставщиков для заказа.',
    poTotal: 'Итого по себестоимости',
    cancel: 'Отмена',
    poCreate: 'Создать заказов: {{count}}',
    toastSwapped: '{{sku}} заменён в спецификации',
    toastSaved: 'Спецификация сохранена как черновик',
    toastCreated: 'Создано черновиков заказов: {{count}}',
  },
  po: {
    eyebrow: 'Заказы поставщикам',
    title: 'Заказы поставщикам',
    description: 'Каждый заказ привязан к спецификации клиента и считается по цене поставщика. Отправка — по e-mail или в WhatsApp.',
    newOrder: 'Новый заказ из спецификации',
    openValue: 'Сумма открытых заказов',
    inProgress: 'Заказов в работе',
    deliveredValue: 'Поставлено на сумму',
    unitsOnOrder: 'Единиц в заказах',
    note: 'Сумма по себестоимости · цены фиксируются при создании',
    colPo: 'Номер заказа',
    colPartner: 'Поставщик',
    colSpec: 'Спецификация',
    colLines: 'Строк',
    colTotal: 'Сумма по себестоимости',
    colCreated: 'Создан',
    colStatus: 'Статус',
    units: '{{count}} ед.',
    empty: 'Заказов с таким статусом нет.',
    footer1: '{{shown}} из {{total}} заказов',
    footer2: 'Срок брони поставщика начинается с момента подтверждения заказа',
  },
  poDetail: {
    back: 'Заказы поставщикам',
    notFound: 'Заказ не найден',
    backToPo: 'К заказам',
    meta: '{{partner}} · {{spec}} · создан {{created}} · нужен {{expected}}',
    sendEmail: 'Отправить на e-mail',
    sendWa: 'Отправить в WhatsApp',
    downloadPdf: 'Скачать PDF',
    emailed: 'Заказ отправлен на e-mail {{partner}}',
    pdfDone: 'PDF сформирован и скачан',
    pdfPreview: 'Просмотр PDF',
    pdfMeta: 'Страница 1 из 1 · A4',
    company: 'Treejar Trading LLC',
    tagline: 'Офисная мебель · Дубай, ОАЭ',
    docTitle: 'Заказ поставщику',
    issued: 'Выставлен {{date}}',
    supplier: 'Поставщик',
    supplierAddress1: 'Склад №6, Industrial Area 18',
    supplierAddress2: 'Шарджа, Объединённые Арабские Эмираты',
    deliverTo: 'Адрес поставки',
    deliverAddress1: 'Emaar Business Park, Tower 3',
    deliverAddress2: '12 этаж, Sheikh Zayed Road',
    deliverAddress3: 'Дубай, Объединённые Арабские Эмираты',
    attn: 'Внимание: прораб объекта',
    colSku: 'Артикул',
    colDescription: 'Наименование',
    colQty: 'Кол-во',
    colUnitCost: 'Цена за ед.',
    colAmount: 'Сумма',
    subtotal: 'Итого по себестоимости',
    vat: 'НДС 5% (к возмещению)',
    totalInclVat: 'Итого с НДС',
    termsTitle: 'Условия',
    termsBody: 'Оплата в течение 30 дней с даты поставки. Остаток бронируется на 48 часов после подтверждения. Доставка по Дубаю и Шардже включена при заказе от 2 500 AED.',
    authorisedBy: 'Подписал',
    authorisedName: 'Лейла Хассан',
    authorisedRole: 'Менеджер поставщиков, Treejar Trading',
    itemsTitle: 'Позиции заказа',
    itemsMeta: '{{lines}} строк · {{units}} ед.',
    totalAtCost: 'Итого по цене поставщика',
    statusTitle: 'Статус заказа',
    statusUpdated: 'Статус изменён на «{{status}}»',
    timeline1: 'Черновик создан',
    timeline2: 'Отправлен поставщику',
    timeline3: 'Поставщик подтвердил',
    timeline4: 'Забран / доставлен',
    partnerTitle: 'Поставщик',
    paymentTerms: 'Условия оплаты',
    net30: 'Оплата в течение 30 дней',
    reservation: 'Бронь остатка',
    hours48: '48 часов',
    delivery: 'Доставка',
    included: 'Включена',
    openPartner: 'Открыть поставщика',
    linkedSpec: 'Связанная спецификация',
    linkedNote: 'Цены продажи в спецификации не меняются при последующих изменениях прайса поставщика.',
    waMessage: 'Здравствуйте, {{partner}}! Это Treejar Trading. Просим подтвердить заказ {{po}} на {{lines}} строк ({{units}} ед.) на сумму AED {{total}} по себестоимости. Требуемая поставка: {{date}}.',
  },
  sf: {
    eyebrow: 'Витрина',
    title: 'Что видят клиенты на treejartrading.ae',
    description: 'Только опубликованные позиции. Названия поставщиков, их цены и маржа скрыты — клиент видит бренд Treejar, цену продажи и наличие.',
    previewMode: 'Режим просмотра',
    openLive: 'Открыть сайт',
    publishChanges: 'Опубликовать изменения',
    publishToast: 'Снимок из {{count}} опубликованных позиций отправлен на сайт',
    urlPath: 'treejartrading.ae/office-furniture',
    preview: 'Просмотр',
    topbar: 'Проектные цены в течение 24 часов · Доставка по всем ОАЭ',
    nav1: 'Офисная мебель',
    nav2: 'Проекты',
    nav3: 'О компании',
    nav4: 'Контакты',
    requestQuote: 'Запросить цену',
    categoryEyebrow: 'Офисная мебель',
    heroTitle: 'Кресла и столы со склада в Дубае',
    heroSub: 'Мебель контрактного класса со склада в Дубае для оснащения офисов по всем Эмиратам.',
    products: 'Товаров: {{count}}',
    inStockDubai: 'В наличии · Дубай',
    availableIn: 'Доступно через {{weeks}} нед.',
    from: 'От',
    requestQuoteBtn: 'Запросить цену',
    showAll: 'Показать все товары ({{count}})',
    noProducts: 'В этой категории нет опубликованных товаров.',
    address: 'Treejar Trading LLC · Al Quoz Industrial 4, Дубай · sales@treejartrading.ae',
    footerNote: 'Цены без НДС · Сроки поставки подтверждаются в предложении',
    previewNote: 'Просмотр использует текущие флаги публикации. Скрытие товара сразу убирает его из этого вида.',
    rulesTitle: 'Правила витрины',
    rule1: 'Только опубликованные позиции с подписанным договором',
    rule2: 'Только цена продажи и статус наличия',
    rule3: 'Без названий поставщиков, себестоимости и маржи',
    rule4: 'Клиент не видит точных остатков',
    pubTitle: 'Статус публикации',
    publishedItems: 'Опубликовано',
    hiddenItems: 'Скрыто',
    blockedByContract: 'Заблокировано договором',
    blockedNote: 'Договор Emirates Seating истёк, поэтому 2 опубликованные позиции удержаны.',
    clientActions: 'Действия клиента',
    clientActionsBody: 'Кнопка «Запросить цену» открывает форму запроса Treejar. Заявки попадают в раздел «Формы» и в почту отдела продаж.',
  },
  sfQuote: {
    title: 'Запрос цены',
    close: 'Закрыть форму',
    fullName: 'Имя и фамилия',
    yourName: 'Ваше имя',
    company: 'Компания',
    companyPlaceholder: 'Название компании',
    email: 'Рабочий e-mail',
    emailPlaceholder: 'you@company.ae',
    quantity: 'Количество',
    details: 'Детали проекта',
    detailsPlaceholder: 'Адрес поставки, сроки, требования к отделке',
    sending: 'Отправляем',
    send: 'Отправить запрос',
    note: 'Это просмотр реальной формы на treejartrading.ae',
    successTitle: 'Запрос получен',
    successBody: 'Специалист Treejar ответит в течение одного рабочего дня с ценами и наличием.',
    closeBtn: 'Закрыть',
    errorFallback: 'Не удалось отправить запрос. Проверьте данные и попробуйте снова.',
    errorNetwork: 'Ошибка сети — проверьте подключение и попробуйте снова.',
  },
  src: {
    webTitle: 'Сайт поставщика',
    webSub: 'Спарсите каталог с сайта дилера — найденные цены и остатки сверятся с текущим прайсом.',
    urlLabel: 'Адрес каталога на сайте',
    urlPlaceholder: 'https://partner-site.ae/catalog',
    parse: 'Спарсить сайт',
    reparse: 'Спарсить заново',
    progress: 'Сканировано страниц: {{page}} из {{total}}',
    lastParsed: 'Последний разбор: {{date}}',
    noSite: 'Сайт не указан — вставьте адрес каталога, чтобы спарсить товары.',
    statPages: 'Страниц',
    statItems: 'Позиций',
    statMatched: 'Совпало с прайсом',
    statNew: 'Новых позиций',
    colItem: 'Позиция',
    colPrice: 'Цена на сайте',
    colStock: 'Остаток',
    colMatch: 'Сверка',
    matched: 'Совпадает',
    unmatched: 'Нет в прайсе',
    importBtn: 'Добавить в кабинет',
    importedToast: 'Добавлено в кабинет новых позиций: {{count}}',
    importedNote: 'Позиции сохранены в кабинет как черновики — опубликуйте их после проверки.',
    docsTitle: 'Документы поставщика',
    docsSub: 'Каталог, прайс-лист и договор хранятся приватно и доступны только вашей команде.',
    kindCatalog: 'Каталог',
    kindPrice: 'Прайс-лист',
    kindContract: 'Договор',
    kindCatalogDesc: 'PDF, Excel или фото каталога с моделями и отделками',
    kindPriceDesc: 'Прайс с ценами, остатками и доплатами за опции',
    kindContractDesc: 'Подписанный договор на перепродажу, только PDF',
    upload: 'Загрузить файл',
    processing: 'Обрабатываем…',
    ready: 'Готов к работе',
    signed: 'Подписан',
    awaitSignature: 'Ожидает подписи',
    markSigned: 'Отметить подписанным',
    signedToast: 'Договор отмечен как подписанный — публикация разблокирована',
    uploadToast: 'Файл {{name}} загружен и поставлен в обработку',
    removeDoc: 'Удалить {{name}}',
    emptyDocs: 'Документов пока нет — загрузите каталог, прайс или договор.',
    docsFoot: 'Файлы читаются распознавателем: из каталога подтягиваются характеристики, из прайса — цены и остатки.',
    contactTitle: 'Контактные данные менеджера',
    contactSub: 'Кому отправляются заказы с сайта и запросы по остаткам',
    fName: 'Имя и фамилия',
    fRole: 'Должность',
    fPhone: 'Телефон / WhatsApp',
    fEmail: 'E-mail',
    fHours: 'Рабочие часы',
    fLang: 'Языки общения',
    saveContacts: 'Сохранить контакты',
    contactSaved: 'Контактные данные менеджера сохранены',
    contactNote: 'Заказы из витрины приходят этому менеджеру в WhatsApp и на почту. Внутренние заметки поставщику не видны.',
    gateTitle: 'Готовность поставщика',
    gateSub: 'Что уже подключено для публикации и заказов',
    gateSite: 'Сайт спарсен',
    gateCatalog: 'Каталог загружен',
    gatePrice: 'Прайс-лист загружен',
    gateContract: 'Договор подписан',
    notSet: 'Не задано',
    openOrders: 'Заказы с сайта',
  },
  wo: {
    title: 'Заказы с сайта',
    sub: 'Позиции treejartrading.ae, которые нужно закупить у этого поставщика. Отправка — в WhatsApp или на почту менеджера.',
    kpiNew: 'Ждут отправки',
    kpiNewHint: 'новые заказы с витрины',
    kpiUnits: 'Единиц к заказу',
    kpiUnitsHint: 'по неотправленным',
    kpiValue: 'Сумма по себестоимости',
    kpiValueHint: 'цены поставщика',
    kpiSent: 'Отправлено',
    kpiSentHint: 'за последние 30 дней',
    send: 'Отправить',
    resend: 'Повторить',
    sendSelected: 'Отправить: {{count}}',
    colOrder: 'Заказ',
    colClient: 'Клиент',
    colItems: 'Позиции поставщика',
    colUnits: 'Ед.',
    colTotal: 'Себестоимость',
    colStatus: 'Статус',
    colAction: 'Действие',
    selectAll: 'Выбрать все заказы',
    selectOrder: 'Выбрать заказ {{no}}',
    fromSite: 'с treejartrading.ae',
    empty: 'Заказов с сайта для этого поставщика пока нет.',
    foot: 'В заказ поставщику попадают только его позиции · цены фиксируются в момент отправки',
    note: 'Клиент видит бренд Treejar и цену продажи. Поставщик получает только артикулы, количество и адрес поставки — без цены перепродажи и данных клиента.',
    modalTitle: 'Отправить заказ поставщику',
    modalSub: 'Получатель: {{name}} · заказов: {{count}}',
    previewLabel: 'Сообщение поставщику',
    msgGreeting: 'Здравствуйте, {{name}}!',
    msgIntro: 'Treejar Trading передаёт заказы, проданные на сайте. Просим подтвердить наличие и срок поставки:',
    msgLine: '• {{no}} — {{client}} · {{units}} ед. · AED {{total}} по себестоимости',
    msgOutro: 'Доставка на склад Treejar, Al Quoz. Спасибо!',
    sendEmail: 'На e-mail',
    sendWa: 'В WhatsApp',
    sent: 'Заказ {{no}} отправлен {{name}}',
    sentBulk: 'Отправлено заказов: {{count}} · получатель {{name}}',
  },
  set: {
    eyebrow: 'Настройки',
    title: 'Настройки рабочей области',
    description: 'Коммерческие правила, доступы команды и то, как каталог выглядит на витрине для клиентов.',
    save: 'Сохранить изменения',
    saved: 'Настройки сохранены',
    tabPricing: 'Правила цен',
    tabUsers: 'Пользователи и роли',
    tabRoles: 'Права ролей',
    tabCosts: 'Расходы и согласования',
    tabStorefront: 'Витрина',
    tabFeedback: 'Замечания',
    tabAudit: 'Журнал',
    rulesTitle: 'Правила перепродажи',
    rulesSub: 'Применяются при публикации прайса поставщика. Отдельные позиции могут переопределять наценку.',
    markup: 'Наценка по умолчанию',
    rounding: 'Округление цены',
    rounding5: 'До 5 AED',
    rounding10: 'До 10 AED',
    rounding1: 'До 1 AED',
    roundingNone: 'Без округления',
    staleThreshold: 'Порог устаревания прайса',
    days: 'дн.',
    minMarginGuard: 'Минимальная маржа',
    guardLabel: 'Блокировать цены ниже минимальной цены перепродажи поставщика',
    guardDesc: 'Приоритетнее проектных скидок и ручных правок цены.',
    mergeLabel: 'Объединять дубли артикулов при импорте прайса',
    mergeDesc: 'Дубли объединяются и помечаются на шаге проверки.',
    gateLabel: 'Требовать подписанный договор для публикации товаров поставщика',
    gateDesc: 'Блокирует публикацию на витрине и новые заказы для неподписанных поставщиков.',
    exampleTitle: 'Пример расчёта',
    exampleSub: 'CH-229A · цена поставщика 305 AED, скидка 18%',
    exPartnerPrice: 'Цена поставщика',
    exAfterDiscount: 'После скидки 18%',
    exMarkup: 'Наценка {{value}}%',
    exRounded: 'С округлением',
    exMargin: 'Маржа, %',
    roundingNote: 'Округление: {{rounding}}. Защита блокирует всё, что ниже маржи {{margin}}%.',
    teamTitle: 'Доступ команды',
    teamSub: '5 мест · администратор может менять роли в любой момент',
    invite: 'Пригласить',
    inviteToast: 'Ссылка-приглашение скопирована — отправьте её коллеге',
    colUser: 'Пользователь',
    colRole: 'Роль',
    colStatus: 'Статус',
    colLast: 'Последняя активность',
    roleAdmin: 'Администратор',
    rolePartner: 'Менеджер поставщиков',
    roleProject: 'Проектный менеджер',
    roleViewer: 'Наблюдатель',
    roleFinance: 'Финансы',
    roleFor: 'Роль для {{name}}',
    statusActive: 'Активен',
    rolesTitle: 'Права ролей',
    rolesAdminDesc: 'Полный доступ, правила цен, пользователи, договоры',
    rolesPartnerDesc: 'Поставщики, импорт прайсов, публикация',
    rolesProjectDesc: 'Спецификации, заказы, каталог',
    rolesViewerDesc: 'Только чтение каталога и спецификаций',
    rolesFinanceDesc: 'Оплаты клиентов и партнёров, сверка с Zoho',
    displayTitle: 'Витрина для клиентов',
    displaySub: 'Управляет тем, что видно на treejartrading.ae.',
    showStockLabel: 'Показывать клиентам точные остатки',
    showStockDesc: 'По умолчанию выключено — клиент видит статус наличия вместо количества.',
    approvalLabel: 'Требовать одобрение перед публикацией изменений каталога',
    approvalDesc: 'Администратор должен одобрить обновления витрины перед публикацией.',
    leadLabel: 'Текст срока поставки',
    leadNote: 'Используйте {weeks} как подстановку количества недель.',
    currency: 'Валюта',
    currencyValue: 'AED — дирхам ОАЭ',
    quoteDest: 'Куда приходят запросы',
    quoteDestValue: 'Раздел «Формы» · почта отдела продаж',
    previewLabels: 'Примеры статусов',
    inStockDubai: 'В наличии · Дубай',
    labelsNote: 'Названия поставщиков, их цены и себестоимость никогда не выводятся на витрине, независимо от этих настроек.',
  },
};